import { Component, Input } from '@angular/core';
import { DATE_FORMAT } from 'src/app/shared/constants/date-format';
import { Allowance } from 'src/app/shared/models/allowance.model';
import { Nullable } from 'src/app/shared/constants/types'

@Component({
  selector: 'app-allowance-form',
  templateUrl: './allowance-form.component.html',
  styleUrls: ['./allowance-form.component.scss'],
})
export class AllowanceFormComponent {
	@Input() public allowances: Allowance[] = [];
	@Input() public editable = false;
	public readonly DATE_FORMAT = DATE_FORMAT;

	getModificationDate(allowance:Allowance ) : Nullable<Date> {
		return (allowance)?allowance.modificationDate:null;
	}
}
